import { WritableSignal } from '@angular/core';

function compare(one: string, other: string): number {
  return one < other ? -1 : one > other ? 1 : 0;
}

export abstract class Chip<T = unknown> {
  constructor(
    public readonly key: string,
    public readonly signal: WritableSignal<T>,
  ) {}

  get id() {
    return this.label;
  }

  abstract get label(): string;

  abstract remove(): void;

  compare(other: Chip<unknown>) {
    return compare(this.key, other.key);
  }
}

export class BooleanChip extends Chip<boolean> {
  get label() {
    return this.key;
  }

  remove() {
    this.signal.set(false);
  }
}

export class StringChip extends Chip<string> {
  get label() {
    return `${this.key}: ${this.signal()}`;
  }

  remove() {
    this.signal.set('');
  }
}

export class StringArrayChip extends Chip<string[]> {
  constructor(
    key: string,
    signal: WritableSignal<string[]>,
    public readonly arrayValue: string,
  ) {
    super(key, signal);
  }

  get label() {
    return `${this.key}: ${this.arrayValue}`;
  }

  remove() {
    this.signal.set(this.signal().filter((v) => v != this.arrayValue));
  }

  override compare(other: Chip<string[]>) {
    const c = super.compare(other);
    if (c === 0 && other instanceof StringArrayChip) {
      return compare(this.arrayValue, other.arrayValue);
    }
    return c;
  }
}

export class WKTChip extends Chip<string | undefined> {
  get label() {
    return this.key;
  }

  remove() {
    this.signal.set(undefined);
  }
}
